import {createApi} from '@reduxjs/toolkit/query/react';
import {customBaseQuery} from '~/common/rtk-query/queries';

export const api = createApi({
  reducerPath: 'checkout',
  baseQuery: customBaseQuery({basePath: '/ajax/cart'}),
  tagTypes: ['Cart', 'Packages', 'Event'],
  endpoints: () => ({}),
});
